import { Component, OnInit } from '@angular/core';
import { GastoService } from '../../../services/gasto.service';
import { Gasto } from './../../../models/gasto';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SessionService } from '../../../services/session.service';
import { GastoModalComponent } from '../../../components/modals/gasto-modal/gasto-modal.component';


@Component({
  selector: 'app-gasto-list',
  templateUrl: './gasto-list.component.html',
  styleUrls: ['./gasto-list.component.css'],
  providers: [GastoService]
})
export class GastoListComponent implements OnInit {
  public title: String;
	public Gastos: Array<Gasto> = [];
	public msg: SweetMessage;
	public bsModalRef: BsModalRef;
  public loading = false;
  
  constructor(
    public GastoService: GastoService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private modalService: BsModalService,
		private ss: SessionService,
  ) { 
    this.title = "Gastos";
  }

  ngOnInit() {
    this.msg = new SweetMessage();
		this.getGastos();
  }

  getGastos(){
		this.loading = true;
		this.GastoService.getAll("?embed=proveedor&sort=-fecha_emision,-secuencial&usuario_id="+this.ss.getData('usuario_id')).subscribe(
		//this.GastoService.getAll().subscribe(
			res => {
				this.loading = false;
				if( !res.data.length ){
					this.Gastos = [];
				}else{
					this.Gastos = res.data;
				}
			},
			err => {
				this.loading = false;
				this.Gastos = [];
			}
		);
	}
	
	getNumeroDocumento(gasto){
		return gasto.serie + "-" + gasto.punto_emision + "-" + gasto.secuencial;
	}

	onShow(id){
		const initialState = {gasto_id: id};
		this.bsModalRef = this.modalService.show(GastoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if(res == "ok"){
					this.GastoService.delete(id).subscribe(
						res => {
							if(res.message){
								this.getGastos();
								this.msg.showMessage('success-message',res.message);
							}
						},
						err => {
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/gasto-list/gasto-list.component.ts